import React from 'react';
import { Globe, MessageCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function Header() {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  return <header className="sticky top-0 z-50 w-full bg-brand-navy text-white shadow-md" data-id="element-68">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-69">
        <div className="flex flex-col sm:flex-row justify-between items-center py-3 space-y-3 sm:space-y-0" data-id="element-70">
          <div className="flex items-center space-x-3" data-id="element-71">
            <img src="https://cdn.magicpatterns.com/uploads/7yPi8SpcWoVCMbepvEjrdt/8F2A0D7B-D6F6-4784-A685-41659FF86BD9.png" alt="K.J Premium Marketing Logo" className="h-36 w-auto object-contain rounded-xl p-2" data-id="element-72" />
            <div className="flex flex-col" data-id="element-73">
              <span className="font-bold text-xl leading-tight" data-id="element-74">
                K.J Premium Marketing
              </span>
              <span className="text-base text-gray-300" data-id="element-75">
                {t('header.subtitle')}
              </span>
            </div>
          </div>

          <div className="flex items-center space-x-6" data-id="element-76">
            <div className="flex items-center space-x-1 text-sm font-medium" data-id="element-77">
              <Globe className="w-4 h-4 mr-1" data-id="element-78" />
              <button onClick={() => setLang('es')} className={`cursor-pointer transition-colors ${lang === 'es' ? 'text-brand-accent' : 'text-gray-400 hover:text-white'}`} data-id="element-79">
                [ ES ]
              </button>
              <button onClick={() => setLang('en')} className={`cursor-pointer transition-colors ${lang === 'en' ? 'text-brand-accent' : 'text-gray-400 hover:text-white'}`} data-id="element-80">
                [ EN ]
              </button>
            </div>
            <a href="https://wa.me/12013540888" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 text-sm font-bold hover:text-brand-accent transition-colors" data-id="element-81">
              <MessageCircle className="w-5 h-5 text-brand-accent" data-id="element-82" />
              <span data-id="element-83">+1 201 354 0888</span>
            </a>
          </div>
        </div>
      </div>
    </header>;
}